module.exports = __webpack_public_path__ + "static/img/news2.7d1e746.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/news2.png
// module id = es/i
// module chunks = 7